import { useEffect, useState } from 'react';

const COMPACT_QUERY = '(orientation: landscape) and (max-height: 500px)';

/**
 * True on the same short-landscape-phone viewport targeted by the
 * `(orientation: landscape) and (max-height: 500px)` CSS breakpoint used
 * throughout this app, kept in sync with resize/orientation changes.
 * Needed wherever a control's on-screen size is computed in JS (canvas
 * dimensions, absolute pixel positions) rather than pure CSS, since those
 * can't be reached by a media query at all.
 */
export function useIsCompactViewport() {
  const [isCompact, setIsCompact] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(COMPACT_QUERY).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(COMPACT_QUERY);
    const handleChange = (e) => setIsCompact(e.matches);
    mql.addEventListener('change', handleChange);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return isCompact;
}
